export default __webpack_public_path__ + "static/media/caishen_banking_app_1.ef5fc7ca.mp4";